window.chTypeAhead = (function ($, Bloodhound, _, urlHelper) {
    var engines = (function () {
        var cache = {};

        var sort = {
            active: function (a, b) { return a.active == b.active ? sort.label(a, b) : b.active - a.active; },
            archived: function (a, b) { return a.archived == b.archived ? sort.label(a, b) : a.archived - b.archived; },
            label: function (a, b) { return a.label < b.label ? -1 : (a.label > b.label ? 1 : 0); },
            relevance: function (a, b) { return b.relevance - a.relevance; }
        };

        var ignore = {
            deactivated: function (d) { return d.active === false; },
            archived: function (d) { return d.archived === true; }
        };

        function get(type) {
            if (!cache.hasOwnProperty(type)) {                
                cache[type] = new Bloodhound(getConfig(type));
            }
            return cache[type];
        }

        function getConfig(type) {
            switch (type.toLowerCase()) {
                case 'organisation':
                    return buildConfig({
                        url: '/services/admin/suggest/organisation?s={s}&maxResults=20',
                        value: 'id',
                        label: function (datum) { return datum.name + delimit(' - ', datum.division); },
                        ignore: ignore.deactivated
                    });
                case 'organisationcontact':
                    return buildConfig({
                        url: '/services/admin/suggest/organisationContact?s={s}&active=true',
                        value: 'id',
                        label: function (datum) { return datum.firstName + delimit(', ' , datum.lastName); },
                        ignore: ignore.deactivated
                    });
                case 'activity':
                    return buildConfig({
                        url: '/admin/activities/search/suggest?text={s}&take=20',
                        value: 'id',
                        label: 'title'
                    });
                case 'activitytype':
                    return buildConfig({
                        url: '/services/admin/suggest/' + type,
                        prefetch: { key: type, sort: sort.label },
                        ignore: ignore.archived
                    });
                case 'administrator':
                    return buildConfig({
                        url: '/services/admin/suggest/administrator?maxResults=9000',
                        prefetch: { key: type, sort: sort.active },
                        value: 'id',
                        label: 'name',
                        tokens: ['position'],
                        ignore: ignore.deactivated
                    });
                case 'administratorverifier':
                    return buildConfig({
                        url: '/services/admin/suggest/administrator?maxResults=9000&permissionKey=Experiences.Verify',
                        prefetch: { key: type, sort: sort.active },
                        value: 'id',
                        label: 'name',
                        tokens: ['position'],
                        ignore: ignore.deactivated
                    });
                case 'jounraljabel':
                case 'generallabel':
                    return buildConfig({
                        url: '/services/admin/suggest/label?type=' + type.substring(0, 7),
                        prefetch: { key: type, sort: sort.archived },
                        ignore: ignore.archived
                    });
                case 'jobseeker':
                    return buildConfig({
                        url: '/services/admin/suggest/jobseeker?s={s}&maxResults=20',
                        value: 'id',
                        label: function (datum) { return datum.firstName + ' ' + datum.lastName; }
                    });
                case 'campus':
                    return buildConfig({
                        url: '/services/admin/suggest/' + type,
                        prefetch: { key: type, sort: sort.label }
                    });
                case 'campusbuilding':
                    return buildConfig({
                        url: '/services/admin/suggest/' + type + '?s={s}&maxResults=20'
                    });
                case 'oncampuslocation':
                    return buildConfig({
                        url: '/services/admin/suggest/' + type + '?s={s}&maxResults=20'
                    });
                case 'developer':
                    return buildConfig({
                        url: '/services/admin/suggest/developers',
                        value: 'id',
                        prefetch: { key: type, sort: sort.label },
                        label: function (datum) { return datum.name + delimit(' - ', datum.company); }
                    });
                case 'experiencetype':
                    return buildConfig({
                        url: '/services/admin/suggest/category?key=' + type,
                        prefetch: { key: type, sort: sort.active },
                        ignore: ignore.deactivated
                    });
                case 'event':
                    return buildConfig({
                        url: '/services/admin/suggest/event?s={s}&maxResults=20',
                        value: 'id',
                        label: 'title'
                    });
                case 'country':
                    return buildConfig({
                        url: '/countries',
                        value: 'code',
                        label: 'name',
                        tokens: ['code', 'alpha3', 'aliases'],
                        prefetch: { key: type, sort: sort.relevance, cache: true }
                    });
                case 'eventtype':
                    return buildConfig({
                        url: '/services/admin/suggest/' + type,
                        prefetch: { key: type, sort: sort.label },
                        ignore: ignore.archived
                    });
                case 'skill':
                    return buildConfig({
                        url: '/services/admin/suggest/skill',
                        prefetch: { key: type, sort: sort.label },
                        ignore: ignore.archived
                    });
                case 'workgroup':
                    return buildConfig({
                        url: '/services/admin/suggest/' + type,
                        prefetch: { key: type }
                    });
                case 'major':
                    return buildConfig({
                        url: '/services/admin/suggest/major?s={s}&maxResults=20',
                        value: 'value',
                        label: 'value'
                    });
                case 'resourcetopic':
                    return buildConfig({
                        url: '/services/admin/suggest/resourcetopic?s={s}'
                    });
                case 'guesttracker':
                    return buildConfig({
                        url: '/services/admin/suggest/guestTracker?s={s}&Active=true',
                        value: 'entityId',
                        label: function (datum) { return datum.firstName + delimit(', ', datum.lastName); },
                        ignore: ignore.deactivated
                    });
                case 'endorsement':
                    return buildConfig({
                        url: '/services/admin/suggest/endorsements?s={s}',
                        value: 'id',
                        label: 'name',
                        ignore: ignore.archived
                    });
                default:
                    throw "'" + type + "' type not supported";
            }
        }

        function buildConfig(config) {
            if (!config.value) config.value = 'id';
            if (!config.label) config.label = 'name';
            
            var opts = {
                initialize: false,
                queryTokenizer: Bloodhound.tokenizers.whitespace,
                datumTokenizer: function (datum) {
                    var tokens = [];

                    if (config.ignore && config.ignore(datum)) {
                        return [];
                    }
                    if (datum.label) {
                        tokens = tokens.concat(Bloodhound.tokenizers.whitespace(datum.label));
                    }
                    if (datum.label != datum.value) {
                        tokens.push('' + datum.value);
                    }
                    if (config.tokens) {
                        _.each(config.tokens, function (key) {
                            var val = datum[key];
                            if (!val) {
                                return;
                            } else if (_.isString(val)) {
                                tokens = tokens.concat(Bloodhound.tokenizers.whitespace(val));
                            } else if (_.isArray(val)) {
                                _.each(val, function (subVal) {
                                    tokens = tokens.concat(Bloodhound.tokenizers.whitespace(subVal));
                                });
                            }
                        });
                    }
                    return tokens;
                },
                identify: function (datum) {
                    return datum.value;
                }
            };

            var transform = function (data) {
                if (config.transform) {
                    data = getter(data, config.transform);
                }
                _.each(data, function (item) {
                    item.value = getter(item, config.value);
                    item.label = getter(item, config.label);
                });

                if (config.prefetch) {
                    if (config.prefetch.sort) {
                        data.sort(config.prefetch.sort);
                    }
                    _.each(data, function (item, i) {
                        item.i = i;
                    });
                }

                return data;
            };

            var url = urlHelper.resolveUrl(config.url);
            
            if (config.prefetch) {
                opts.prefetch = {
                    url: url,
                    cache: config.prefetch.cache === true,
                    cacheKey: config.prefetch.key,
                    transform: transform,
                    prepare: function (settings) {
                        settings.contentType = "application/json; charset=utf-8";
                        return settings;
                    }
                };
            } else {
                opts.remote = {
                    url: url,
                    transform: transform,
                    prepare: function (query, settings) {
                        // Need full control of setting preparation just to set contentType
                        // That means we need to manage 'wildcard' setting manually
                        settings.contentType = "application/json; charset=utf-8";
                        // 'wildcard' behaviour taken from \Web\Scripts\lib\typeahead.js\bloodhound.js > prepareByWildcard
                        settings.url = settings.url.replace('{s}', encodeURIComponent(query));
                        return settings;
                    }
                };
            }

            return opts;
        }

        function delimit(before, value, after) {
            if (value === '' || value == null) {
                return '';
            } else {
                return (before == null ? '' : before) + value + (after == null ? '' : after);
            }
        }

        function getIndex(type) {
            var deferred = $.Deferred();

            var engine = get(type);

            engine.initialize()
                .done(function () {
                    deferred.resolveWith(this, [_.sortBy(engine.index.datums, 'i'), engine]);
                })
                .fail(function () {
                    deferred.rejectWith(this, arguments);
                });

            return deferred;
        }

        return {
            get: get,
            getIndex: getIndex
        };
    }());

    var dataSets = (function () {
        function boolLabel(prop, text, style, expected) {
            if (expected === undefined) {
                expected = true;
            }

            var cfg = {
                getter: function (d) {
                    return (d.hasOwnProperty(prop) && d[prop] === expected) ? (text ? text : prop) : null;
                }
            };

            if (style) {
                cfg.style = function (d) { return style; };
            }
            return cfg;
        }

        function getStatusStyle(status) {
            switch (status?.toLowerCase()) {
                case 'deleted':
                case 'cancelled': return 'danger';
                case 'expired':
                case 'ended':
                case 'prelisted': return 'warning';
                case 'published': return 'success';
                default: return "secondary";
            }
        }

        var label = {
            archived: boolLabel('archived', 'archived', 'warning'),
            deactivated: boolLabel('active', 'disabled', 'warning', false),
            Deactivated: boolLabel('Active', 'disabled', 'warning', false),
            status: {
                getter: function (d) { return d.status ? d.status.toUpperCase() : null; },
                style: function (d) { return getStatusStyle(d.status); }
            },
            Status: {
                getter: function (d) { return d.Status ? d.Status.toUpperCase() : null; },
                style: function (d) { return getStatusStyle(d.Status); }
            }
        };

        function get(type) {
            var dataset = {
                display: 'label',
                name: type,
                source: engines.get(type).ttAdapter(),
                // Bug when using limit (better to use server-side limit anyway): https://github.com/twitter/typeahead.js/issues/1795
                // This means prefetched data isn't limited when searching, however prefetched data should always be small or it shouldn't be prefetched
                limit: Infinity,
                templates: {
                    pending: '<div class="tt-pending">Searching...</div>',
                    notFound: '<div class="tt-notfound">No matches</div>'
                }
            };

            switch (type.toLowerCase()) {
                case 'activity':
                    setTableTemplates(dataset, [
                        { name: 'Title', getter: 'label', span: 6, labels: [label.status] },
                        { name: 'Location', getter: 'location', span: 6 }
                    ]);
                    break;
                case 'activitytype':
                    dataset.templates.suggestion = getLabelledSuggestion(label.archived);
                    break;
                case 'event':
                    setTableTemplates(dataset, [
                        { name: 'Title', getter: 'label', span: 5, labels: [label.status] },
                        { name: 'Date', getter: 'start', span: 3 },
                        { name: 'Venue', getter: 'venue', span: 4 }
                    ]);
                    break;
                case 'jobseeker':
                    setTableTemplates(dataset, [
                        { name: 'Name', getter: function (datum) { return datum.firstName + ' ' + datum.lastName; }, span: 5 },
                        { name: 'Student No.', getter: 'externalId', span: 3 },
                        { name: 'Email', getter: 'email', span: 4 }
                    ]);
                    break;
                case 'eventtype':
                    dataset.templates.suggestion = getLabelledSuggestion(label.archived);
                    break;
                case 'experiencetype':
                    dataset.templates.suggestion = getLabelledSuggestion(label.archived);
                    break;
                case 'workgroup':
                    dataset.templates.suggestion = getLabelledSuggestion(
                        boolLabel('openToJobSeekers', 'open to students', 'warning'), // TODO: use strings
                        boolLabel('openToAdministrators', 'open to admin', 'warning'),
                        boolLabel('default', null, 'info', true)
                    );
                    break;
                case 'jounrallabel':
                case 'generallabel':
                    dataset.templates.suggestion = getLabelledSuggestion(
                        boolLabel('archived', null, 'warning'),
                        boolLabel('private', null, 'info')
                    );
                    break;
                case 'organisation':
                    setTableTemplates(dataset, [
                        { name: 'Name - Division', getter: 'label', span: 6, labels: [label.deactivated] },
                        { name: 'Email', getter: 'email', span: 6 }
                    ]);
                    break;
                case 'organisationcontact':
                    setTableTemplates(dataset, [
                        { name: 'Contact', getter: 'label', span: 4 },
                        { name: 'Name - Division', getter: 'organisationName', span: 4, labels: [label.deactivated] },
                        { name: 'Email', getter: 'email', span: 4, labels: [label.deactivated] }
                    ]);
                    break;
                case 'guesttracker':
                    setTableTemplates(dataset, [
                        { name: 'Name', getter: 'label', span: 4 },
                        { name: 'Email', getter: 'email', span: 4 },
                        { name: 'Type', getter: 'typeDescription', span: 4, labels: [label.deactivated] }
                    ]);
                    break;
                case 'administrator':
                    setTableTemplates(dataset, [
                        { name: 'Name', getter: 'label', span: 4, xsSpan:12, labels: [label.deactivated] },
                        { name: 'Email', getter: 'email', span: 4, xsSpan: 12 },
                        { name: 'Position', getter: 'position', span: 4, xsSpan: 12 }
                    ]);
                    break;
                case 'developer':
                    setTableTemplates(dataset, [
                        { name: 'Developer ID', getter: 'id', span: 4 },
                        { name: 'Name', getter: 'label', span: 2 },
                        { name: 'Email', getter: 'email', span: 3 },
                        { name: 'Company', getter: 'company', span: 3 }
                    ]);
                    break;
                case 'campus':
                    dataset.templates.suggestion = getLabelledSuggestion(label.deactivated);
                    break;
                case 'campusbuilding':
                    setTableTemplates(dataset, [
                        { name: 'Name', getter: 'label', span: 6, labels: [label.archived] },
                        { name: 'Campus', getter: 'campusName', span: 6 }
                    ]);
                    break;
                case 'oncampuslocation':
                    setTableTemplates(dataset, [
                        { name: 'Name', getter: 'label', span: 4, labels: [label.archived] },                        
                        { name: 'Building', getter: 'buildingName', span: 4 },
                        { name: 'Campus', getter: 'campusName', span: 4 }
                    ]);
                    break;
                case 'major':
                    setTableTemplates(dataset, [
                        { name: 'Name', getter: 'id', span: 12 }
                    ]);
                    break;
                case 'skill':
                    setTableTemplates(dataset, [
                        { name: 'Name', getter: 'label', span: 6, labels: [label.archived] },
                        { name: 'Classification', getter: 'classification', span: 6 }
                    ]);
                    break;
                case 'resourcetopic':
                    setTableTemplates(dataset, [
                        { name: 'Name', getter: 'label', span: 6, labels: [label.archived] },
                        { name: 'Promoted', getter: 'promoted', span: 6 }
                    ]);
                    break;
                case 'endorsement':
                    setTableTemplates(dataset, [
                        { name: 'Name', getter: 'label', span: 6, labels: [label.archived] },
                        { name: 'Acronym', getter: 'acronym', span: 6 }
                    ]);
                    break;
                default:
                    dataset.templates.suggestion = defaultSuggestion;
                    break;
            }

            return dataset;
        }

        function setTableTemplates(dataset, config) {
            dataset.templates.header = getTableHeader(config);
            dataset.templates.suggestion = getTableSuggestion(config);
        }

        function getLabelledSuggestion() {
            var config = arguments;
            return function (datum) {
                return '<div>' + datum.label + '<br class="d-block d-sm-none" />' + getLabels(datum, config) + '</div>';
            };
        }

        function getTableHeader(config) {
            var spans = [];
            $.each(config, function (i, cfg) {
                spans.push('<div class="col-' + cfg.span + '">' + cfg.name + '</div>');
            });
            return '<div class="tt-header"><div class="row">' + spans.join('') + '</div></div>';
        }

        function getTableSuggestion(config) {
            return function (datum) {
                var spans = [];


                $.each(config, function (i, cfg) {
                    var text = getter(datum, cfg.getter);

                    var span = $('<div>')
                        .addClass('col-' + cfg.span)
                        .text(text ? text : '')
                        .append(' ' + getLabels(datum, cfg.labels));

                    spans.push(span[0].outerHTML);
                });

                return '<div><div class="row text-break">' + spans.join('') + '</div></div>';
            };
        }

        function getLabels(datum, config) {
            if (!config) return '';

            var labels = [];

            $.each(config, function (i, cfg) {
                var text = getter(datum, cfg.getter);

                if (text) {
                    var style = getter(datum, cfg.style);

                    var label = $('<span class="badge float-md-right mr-1" >')
                        .addClass('badge-' + (style ? style : 'secondary'))
                        .text(text);

                    labels.push(label[0].outerHTML);
                }
            });

            return labels.join(' ');
        }

        function defaultSuggestion(datum) {
            return $('<div>').text(datum.label);
        }

        return { get: get };
    }());

    function getter(item, prop) {
        return typeof prop === 'function' ? prop(item) : item[prop];
    }

    $.fn.chTypeahead = function (options) {
        var engine = engines.get(options.type);

        if (engine.prefetch) {
            this.on('focus', initializeEngine);
        }

        function initializeEngine(e) {
            engine.initialize();
            $(e.currentTarget).off('focus', initializeEngine);
        }

        if (options.submit) {
            this.on('typeahead:select', function () {
                var form = $(this.form);

                // timeout so typeahead-id executes first
                setTimeout(function () {
                    form.submit();
                });
            });
        }

        var response = this.typeahead({
            highlight: true,
            minLength: 1
        }, dataSets.get(options.type));

        this.closest('.twitter-typeahead').addClass('form-control');

        return response;
    };

    return {
        engines: engines,
        dataSets: dataSets
    };
}(jQuery, Bloodhound, _, urlHelper));
